/**************************************************
 * Nombre:       ListaOfertas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import TarjetaOferta from "../../../Tarjetas/TarjetaOferta";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const ListaOfertas = ({items, cargaMas}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 0 : 3}}
                spacing={6}
            >

                {items.map((e, i) => (
                    <Grid container key={`Rs${i}`} size={{xs: 12, sm: 6, md: 4}} sx={{justifyContent: 'flex-start'}}>
                        <TarjetaOferta item={e}/>
                    </Grid>
                ))}

            </Grid>

        </Grid>
    )

}
export default ListaOfertas

